<template>

  <t-form-wrapped v-if="person !== null" :command="command" :status="status">

    <div class="form-card-header" v-if="!onlyCompany">
      <t-input v-model="person.typePerson" label="Tipo Pessoa"
               :options="typePersonOptions" radio/>
    </div>


    <slot></slot>


    <b-row v-if="isCompany">

      <t-input cols="4" v-model="person.federalTaxpayer" :add-error="error.federalTaxpayer" label="CNPJ"
               :required="!notRequired" cnpj
               api @get="setPersonAndAddress">

        <!--          <template #input-group-append>
                    <t-button icon-list title="Consultar informações junto a Receita"
                              @click="alert('Verificar se há CNPJ e fazer consulta completa junto a Receita')"/>
                  </template>-->

      </t-input>

      <t-input cols="4" v-model="person.provinceTaxpayer" :disabled="!isCompany || person.provinceTaxpayerExempted"
               upper label="Inscrição Estadual"
               :required="isCompany && !person.provinceTaxpayerExempted && (!notRequired && person.federalTaxpayer !== '')">
        <template #input-group-append>
          <div class="input-group-text bg-light">
            <b-form-checkbox v-model="person.provinceTaxpayerExempted" :disabled="!isCompany">
              <small>Isento</small>
            </b-form-checkbox>
          </div>
        </template>
      </t-input>

      <t-input cols="4" v-model="person.cityTaxpayer" :disabled="!isCompany"
               label="Inscrição Municipal"
      />

    </b-row>

    <b-row v-else>
      <t-input cols="6" v-model="person.federalTaxpayer" :add-error="error.federalTaxpayer" label="CPF" cpf
               :required="(!notRequired && person.federalTaxpayer !== '')"/>
      <t-input cols="6" v-model="person.otherPersonalDocument" upper label="RG"/>
    </b-row>

    <b-row v-if="isCompany">

      <b-col cols="12">
        <t-input v-model="person.companyName" label="Razão Social"
                 :required="(!notRequired && person.federalTaxpayer !== '')"/>
      </b-col>

      <t-input cols="8" v-model="person.name" :add-error="error.name" label="Nome Fantasia"
               :required="(!notRequired || person.federalTaxpayer !== '' || nameRequired)"/>
      <t-input cols="4" v-model="person.shortName" label="Nome Curto" max-length="15"
               help="Nome curto de até 15 caracteres com cadastro opcional, porém poderá ser utilizado em locais onde é mais adequado um nome curto do cliente"/>

    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <t-input v-model="person.name" :add-error="error.name" label="Nome"
                 :required="(!notRequired || person.federalTaxpayer !== '') && !nameRequired"/>
      </b-col>
    </b-row>

  </t-form-wrapped>

</template>
<script>

export default {
  name: 'e-person',
  data() {
    return {
      typePersonOptions: [{value: 2, text: "Jurídica"}, {value: 1, text: "Física"}],
    }
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    notRequired: {
      type: Boolean,
      default: false,
    },
    nameRequired: {
      type: Boolean,
      default: false,
    },
    command: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "person", //Nome do objeto
    },
    addressRelationName: {
      type: String,
      default: "address", //Nome do objeto relacionado ao endereço para retorno da API
    },
    person: {
      type: Object,
      default: null
    },
    error: {
      type: Object,
    },
    onlyCompany: Boolean,
  },
  computed: {
    isCompany() {
      return this.person && this.person.typePerson !== 1
    }
  },
  methods: {

    setPersonAndAddress(cnpjAPI) {

      this.$emit("getApi", this.name, this.addressRelationName, cnpjAPI)

    },

  },
  async mounted() {


    if (this.onlyCompany && this.person !== null) {
      this.person.typePerson = 2;
    }

  },

}
</script>
